const { default: request } = require('src/utils/request')
import * as api from 'src/configs/API'

const createItem = (payload) => {
	return request.pmsApi({
		url: api.PMS_APIs.API_CREATEITEM,
		data: payload,
		method: 'POST',
	})
}

const getOrdersTotalOverStatusCP = (payload) => {
	return request.pmsApi({
		url: api.PMS_APIs.API_GET_HPGET_ORDERS_TOTAL_OVER_STATUS_CPN,
		data: payload,
		method: 'POST',
	})
}

const getOrdersTotalOverStatusCOD = (payload) => {
	return request.pmsApi({
		url: api.PMS_APIs.API_GET_HPGET_ORDERS_TOTAL_OVER_STATUS_COD,
		data: payload,
		method: 'POST',
	})
}

const getDebtReport = (payload) => {
	return request.pmsApi({
		url: api.PMS_APIs.API_DEBT_REPORT,
		data: payload,
		method: 'POST',
	})
}

const getOrderCP = (payload) => {
	return request.pmsApi({
		url: api.PMS_APIs.API_GET_CPN_ORDER,
		data: payload,
		method: 'POST',
	})
}

const getOrderCOD = (payload) => {
	return request.pmsApi({
		url: api.PMS_APIs.API_GET_COD_ORDER,
		data: payload,
		method: 'POST',
	})
}

const getChartInfo = (payload) => {
	return request.pmsApi({
		url: api.PMS_APIs.API_CHART_INFO,
		data: payload,
		method: 'POST',
	})
}

const getGetOrderStatus = (payload) => {
	return request.pmsApi({
		url: api.PMS_APIs.API_OMGET_ORDERS_TOTAL_OVER_STATUS,
		data: payload,
		method: 'POST',
	})
}

const searchInvoice = (payload) => {
	return request.invoiceApi({
		url: api.INVOICE_APIS.SEARCH + payload,
		method: 'GET',
	})
}

const downloadInvoice = (payload) => {
	let url = api.INVOICE_ENDPOINT + api.INVOICE_APIS.DOWNLOAD + payload
	window.open(url, '_blank')
}
const viewInvoice = (payload) => {
	return request.invoiceApi({
		url: api.INVOICE_APIS.VIEW + payload,
		method: 'GET',
	})
}
const downloadOptionInvoice = (payload) => {
	return request.invoiceApi({
		url: api.INVOICE_APIS.DOWNLOAD_OPTION + payload,
		method: 'GET',
	})
}

const getTranferList = (payload) => {
	return request.pmsApi({
		url: api.PMS_APIs.GET_TRANFER_LIST,
		method: 'POST',
		data: payload,
	})
}

const downloadFileRpts = (payload) => {
	return request.pmsApi({
		url:
			api.PMS_APIs.DOWNLOAD_CPN +
			`?ClientHubID=${payload?.ClientHubID}&MonthDebit=${payload?.MonthDebit}&DebitVoucherID=${payload?.DebitVoucherID}&RepresentativeID=`,
		method: 'GET',
		data: payload,
	})
}

const updateDraftToUse = (payload) => {
	return request.pmsApi({
		url: api.PMS_APIs.API_UPDATE_DRAFT_TO_USE,
		method: 'POST',
		data: payload,
	})
}

const getWishDate = (payload) => {
	return request.pmsApi({
		url: api.PMS_APIs.API_GET_WISHDATE,
		method: 'POST',
		data: payload,
	})
}

const getProfileHubs = (payload) => {
	return request.pmsApi({
		url: api.default.API_GET_CLIENT_HUBS,
		data: {
			ClientID: payload,
			Status: 'Activated',
		},
		method: 'POST',
	})
}
const profileGetClientHubs = (payload) => {
	return request.pmsApi({
		url: api.default.API_GET_PROFILE_CLIENT_HUBS,
		data: {
			ClientID: payload,
			// Status: 'Activated',
		},
		method: 'POST',
	})
}
const dashboardService = {
	createItem,
	getOrdersTotalOverStatusCOD,
	getOrdersTotalOverStatusCP,
	getDebtReport,
	getOrderCOD,
	getOrderCP,
	getChartInfo,
	getGetOrderStatus,
	searchInvoice,
	downloadInvoice,
	viewInvoice,
	downloadOptionInvoice,
	getTranferList,
	downloadFileRpts,
	updateDraftToUse,
	getProfileHubs,
	getWishDate,
	profileGetClientHubs,
}

export default dashboardService
